<template>
  <div class="search-form">
    <el-row>
      <span class="mr-2">同步时间</span>
      <el-date-picker
        v-model="syncTimeValue"
        type="datetimerange"
        :picker-options="pickerOptions"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
      >
      </el-date-picker>
      <el-input
        v-model="form.keyword"
        @keyup.enter.native="query"
        placeholder="同步的订单编号 搜索..."
        clearable
        style="width:300px"
        class="ml-2"
      >
      </el-input>
      <el-button type="primary" @click="query" class="ml-2">查询</el-button>
      <el-button @click="openAdvqueryDialog">高级搜索</el-button>
    </el-row>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="130px">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="同步结果确认状态">
              <el-checkbox-group v-model="form.syncStatusList">
                <el-checkbox label="N">新增</el-checkbox>
                <el-checkbox label="Y">成功</el-checkbox>
                <el-checkbox label="E">失败</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="同步的订单编号">
              <el-input
                v-model="form.syncOrderNo"
                placeholder="同步的订单编号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item label="接收时间">
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginReceiveTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择时间"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endReceiveTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择时间"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item label="创建时间">
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginCreateTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择时间"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endCreateTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择时间"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          取消查询
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          重置条件
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          数据检索
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = { keyword: '', syncStatusList: ['N', 'Y', 'E'] }
import dayjs from '@/libs/util.date'
export default {
  data() {
    const pickerFormat = (picker, beforeDays, baseDays) => {
      const now = baseDays || dayjs()
      let before = now
      if (beforeDays) {
        before = before.subtract(beforeDays, 'days')
      }
      picker.$emit('pick', [before.startOf('date'), now.endOf('date')])
    }
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      syncTimeValue: [dayjs().startOf('days'), dayjs().endOf('days')],
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick: (picker) => pickerFormat(picker),
          },
          {
            text: '昨天',
            onClick: (picker) =>
              pickerFormat(picker, 0, dayjs().subtract(1, 'days')),
          },
          {
            text: '最近两天',
            onClick: (picker) => pickerFormat(picker, 1),
          },
          {
            text: '最近7天',
            onClick: (picker) => pickerFormat(picker, 6),
          },
          {
            text: '最近30天',
            onClick: (picker) => pickerFormat(picker, 29),
          },
        ],
      },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      const data = {
        ...this.form,
      }
      if (this.syncTimeValue && this.syncTimeValue.length > 0) {
        data.beginSyncTime = dayjs(this.syncTimeValue[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        data.endSyncTime = dayjs(this.syncTimeValue[1]).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      this.$emit('query', data)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
      this.syncTimeValue = [dayjs().startOf('days'), dayjs().endOf('days')]
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
